import React from "react";
import CustomDialog from "../basic/Dialog";
import { useState } from "react";
import reward_coin from "../../assets/images/reward_coin.png";
import { Dialog } from "@headlessui/react";
import IconButton from "../basic/IconButton";
import ic_close from "../../assets/icons/ic_close.svg";

function Popup({ show, close }) {
  return (
    <CustomDialog show={show} close={close}>
      <Dialog.Panel
        className="text-white font-open-sans relative flex flex-col space-y-7 px-8 justify-center items-center rounded-xl text-left shadow-xl transition-all md:mx-32 mx-8 md:my-8 my-5 py-6 sm:my-8 sm:w-full sm:max-w-lg"
        style={{
          background:
            "linear-gradient(0deg, #1F1F25, #1F1F25),linear-gradient(0deg, #25272D, #25272D)",
        }}
      >
        <IconButton
          icon={ic_close}
          className="shadow-xl absolute -top-3 -right-3"
          onClick={() => {
            close();
          }}
        />
        <p className="font-bold font-poppins text-3xl"> Congratulations!</p>
        <div
          className="rounded-xl flex flex-rows space-x-4 justify-between px-8 py-5 bg-[#2C2C32]"
          //   style={{
          //     background:
          //       "background: linear-gradient(0deg, #25272D, #25272D),linear-gradient(0deg, #2C2C32, #2C2C32)",
          //   }}
        >
          <img src={reward_coin} className="w-12 h-12" />
          <p className="text-xl font-normal flex items-center">
            50 Actyv points
          </p>
        </div>
        <div className="flex justify-center items-center">
          <p className="text-md font-normal">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempora
            incidunt quos architecto repellat nemo.
          </p>
        </div>
        <div className="flex justify-center intems-center">
          <button className="px-12 py-3 text-lg font-semibold text-black-400 bg-primary-neonGreen shadow-xl rounded-3xl">
            Continue
          </button>
        </div>
      </Dialog.Panel>
    </CustomDialog>
  );
}

const Reward = () => {
  const [open, setOpen] = useState(true);
  return (
    <div>
      <Popup
        show={open}
        close={() => {
          setOpen(false);
        }}
      />
    </div>
  );
};

export default Reward;
